import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { CompareHelper } from '@barthauer/abc/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { BasysMapFrameService } from '@barthauer/basys/map-frame';
import { Subscription } from 'rxjs';
import { FrameService } from '../../services/frame.service';
import { MobileTicketViewModel } from '../../viewModels/mobileData.tickets.viewModel';
import { TicketNavigationContext } from '../tickets.model';
import { TicketsService } from '../tickets.service';

@Component({
  selector: 'ticket-navigation',
  templateUrl: './ticket-navigation.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  styleUrls: ['./ticket-navigation.component.scss'],
  standalone: false,
})
export class TicketNavigationComponent implements OnInit, OnDestroy {
  public res = ResourceSet.Empty;
  ticketNavigationContext: TicketNavigationContext;
  private subscriptions: Subscription[] = [];

  constructor(
    public frame: BasysMapFrameService,
    private frameService: FrameService,
    public ticketsService: TicketsService,
    private resourceService: ResourceManagerService,
  ) {
    this.subscriptions.push(
      ticketsService.onNavigationContextRefresh().subscribe((context) => (this.ticketNavigationContext = context)),
    );
  }

  async ngOnInit() {
    this.res = await this.resourceService.getResourceSet('abc-maintenance-opera');
  }

  ngOnDestroy() {
    console.log('TicketNavigationComponent_destroy');
    this.subscriptions.forEach((element) => {
      element.unsubscribe();
    });
    this.frameService.dispose();
  }

  isNavDisabled(operation: 'increment' | 'decrement'): boolean {
    const ticketIndex = this.ticketNavigationContext?.ticketIndex;
    const data: MobileTicketViewModel[] = <MobileTicketViewModel[]>(
      this.ticketNavigationContext?.ticketDataContext?.dataSource?.data
    );
    if (data) {
      switch (operation) {
        case 'increment':
          return data[ticketIndex]?.id === data[Object.keys(data).slice(-1)[0]]?.id;
        case 'decrement':
          return ticketIndex === this.tryGetFirstTicketIndex(data, 0);
      }
    }
  }

  private tryGetFirstTicketIndex(data: MobileTicketViewModel[], index: number): number {
    if (this.ticketNavigationContext.ticketDataContext.dataSource?.filteredData?.length > index) {
      if (CompareHelper.isEmptyObject(data[index])) {
        index++;
        return this.tryGetFirstTicketIndex(data, index);
      }
      return index;
    } else {
      return -1;
    }
  }
}
